var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.835,
    height: 19.823,
    viewBox: "0 0 19.835 19.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call_2_",
    "data-name": "call (2)",
    transform: "translate(-5.44 -9.03)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18153",
    "data-name": "Path 18153",
    d: "M6.492,16.762a23.1,23.1,0,0,0,4.6,6.487,22.076,22.076,0,0,0,6.429,4.614,7.7,7.7,0,0,0,2.993.74,2.754,2.754,0,0,0,2.023-.733L24.5,25.912a1.62,1.62,0,0,0-.119-2.278l-2.886-2.886a1.62,1.62,0,0,0-2.278-.119l-.9.9c-.249.186-1.788-.288-3.52-2.019s-2.208-3.272-2.02-3.519l.9-.9a1.62,1.62,0,0,0-.119-2.278L10.671,9.925a1.62,1.62,0,0,0-2.278-.119L6.435,11.765c-.978.977-.957,2.752.057,5Zm.9-4.043,1.958-1.958a.109.109,0,0,1,.075-.022.442.442,0,0,1,.294.14L12.6,13.766c.149.149.162.327.119.37l-.9.9c-1.118,1.119.17,3.577,2.02,5.428A10.2,10.2,0,0,0,16.7,22.535c1.512.683,2.262.261,2.574-.052l.9-.9c.043-.043.22-.03.37.119l2.886,2.886c.149.149.162.327.119.37l-1.958,1.958c-.543.544-1.86.435-3.522-.29a20.718,20.718,0,0,1-6.015-4.331,21.717,21.717,0,0,1-4.328-6.088c-.744-1.648-.869-2.951-.333-3.488Z",
    transform: "translate(0 0)",
    fill: "#172b4d",
    stroke: "#172b4d",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.340e16907c7e886b57bb0daad72d92f1.svg";
export { ForwardRef as ReactComponent };